import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Modal } from 'carbon-components-react';
import { FormField } from '../_shared/formfield/formfield.component';
import flatten from '../_shared/util/flatten';
import Loading from '../_shared/loading/loading.component';
import { RecaptchaService } from '../_shared/services/recaptcha.service';

@inject('appStore', 'routerStore', 'store', 'emailReportForm')
@observer
export default class EmailReportModal extends Component {
    @observable open = false;

    recaptchaService;

    constructor(props) {
        super(props);
        this.recaptchaService = new RecaptchaService(props.appStore);
    }

    async onSubmit(e) {
        e.preventDefault();

        const { emailReportForm } = this.props;

        const isValid = await this.recaptchaService.validateRecaptcha();
        if (isValid) {
            await emailReportForm.submit(e);
        }
    }

    /**
     * close email report modal
     * remove overflow class from body
     * reset store report observables
     */
    closeModal() {
        const { store } = this.props;

        this.open = false;
        document.body.classList.remove('ht-modal-open');

        // wait until modal has closed before resetting
        setTimeout(() => {
            store.reportSuccess = false;
            store.reportLoading = false;
            store.reportError = false;
        }, 500);
    }

    /**
     * Refreshes the page to renew the securityID for the form
     */
    refreshPage() {
        location.reload();
    }

    /**
     * open email report modal
     * add overflow class from body
     * call callback if provided
     */
    openModal() {
        const { onOpenCallback } = this.props;

        this.open = true;
        document.body.classList.add('ht-modal-open');

        // usually save form state on open
        if (onOpenCallback) {
            onOpenCallback();
        }
    }

    /**
     * reusable close button
     */
    closeButton() {
        return <button
            type='button'
            className='ht-button'
            onClick={() => this.closeModal()}
        >
            Close
        </button>;
    }

    /**
     * reusable close button
     */
    refreshButton() {
        return <button
            type='button'
            className='ht-button'
            onClick={() => this.refreshPage()}
        >
            Refresh
        </button>;
    }

    /**
     * render the form for the modal
     */
    renderForm() {
        const { emailReportForm, appStore } = this.props,
            errors = emailReportForm.errors();

        return <>
            <div className='ht-modal-intro'>
                <p>Complete this form to receive a PDF report that shows the minimum heating capacity you need, and details of all the property-specific information you have entered. The information you enter will be displayed at the start of the report. We will not store or share any personal information after generating your report.</p>
                <p>Landlords should retain this report to help prove a rental home meets the heating requirements of the healthy homes standards.</p>
            </div>
            <form className='ht-form' onSubmit={(e) => this.onSubmit(e)}>
                {emailReportForm.map(field => {
                    field.errors = errors[field.path];
                    return (
                        <FormField
                            key={field.id}
                            field={field}
                            formValues={flatten(emailReportForm.values())}
                        />
                    );
                })}
                <input type='hidden' name='securityID' value={appStore.sectoken} />
                <button
                    type='submit'
                    className='ht-button'
                >
                    Email report
                </button>
            </form>
        </>;
    }

    /**
     * render the success message
     */
    renderSuccess() {
        const { store } = this.props;

        return <div className='ht-result-report-success'>
            <p>Your Heating Capacity report has been sent to {store.reportSuccess}</p>
            <p>Landlords should retain this report to help prove this rental home meets the heating requirements of the healthy homes standards.</p>
            <p>{this.closeButton()}</p>
        </div>;
    }

    /**
     * render the error message
     */
    renderError() {
        const { store, appStore } = this.props;

        return <div className='ht-result-report-error'>
            {store.reportError &&
                <>
                    <p>
                        {store.reportError.message}
                    </p>
                    {store.reportError.code && store.reportError.code === 405 ? (
                        <p>
                            {this.refreshButton()}
                        </p>
                    ) : (
                        <p>
                            {this.closeButton()}
                        </p>
                    )}
                </>}
            {(appStore.captchaVerificationError || appStore.isCaptchaVerified === false) &&
                <>
                    <p>{appStore.captchaVerificationError}</p>
                    <div>{this.refreshButton()}</div>
                </>}
        </div>;
    }

    render() {
        const { store, appStore } = this.props;

        let heading, content;

        if (store.reportLoading) {
            heading = '';
            content = <Loading />;
        } else if (store.reportSuccess) {
            heading = 'Thank you';
            content = this.renderSuccess();
        } else if (store.reportError || appStore.captchaVerificationError) {
            heading = '';
            content = this.renderError();
        } else {
            heading = 'Your Heating Capacity report';
            content = this.renderForm();
        }

        return <Modal
            open={this.open}
            id='email-report-modal'
            className='ht-modal'
            modalHeading={heading}
            modalAriaLabel={heading}
            passiveModal
            danger={false}
            onRequestClose={() => this.closeModal()}
        >
            {content}
        </Modal>;
    }
}
